import { EQUAL_FILTER, GREATER_FILTER, ICondoWeeksFilters, LOWER_FILTER, RANGE_FILTER } from "@common-types";
import { NULL_VALUE } from "@constants";
import { isEmpty } from "lodash";

export const INITIAL_FITLERS: ICondoWeeksFilters = {
  checkInCondition: EQUAL_FILTER,
  fromCheckIn: NULL_VALUE,
  toCheckIn: NULL_VALUE,
  checkOutCondition: EQUAL_FILTER,
  fromCheckOut: NULL_VALUE,
  toCheckOut: NULL_VALUE,
  lengthOfStay: NULL_VALUE,
  occupancy: NULL_VALUE,
  bedrooms: NULL_VALUE,
  bathrooms: NULL_VALUE,
  locationName: NULL_VALUE,
  priceCondition: EQUAL_FILTER,
  startPrice: NULL_VALUE,
  endPrice: NULL_VALUE,

  applied: false,
  loading: false,
  locations: []
};

export const ProcessFilterParams = (filters: ICondoWeeksFilters) => {
  const checkInCondition = filters?.checkInCondition;
  const fromCheckIn = filters?.fromCheckIn;
  const toCheckIn = filters?.toCheckIn;
  const checkOutCondition = filters?.checkOutCondition;
  const fromCheckOut = filters?.fromCheckOut;
  const toCheckOut = filters?.toCheckOut;
  const locationName = filters?.locationName;
  const lengthOfStay = filters?.lengthOfStay;
  const priceCondition = filters?.priceCondition;
  const startPrice = filters?.startPrice;
  const endPrice = filters?.endPrice;
  const maxOccupancy = filters?.occupancy;
  const bedrooms = filters?.bedrooms;
  const bathrooms = filters?.bathrooms;

  let filterApplied = false;

  let checkInParam = '';
  let checkOutParam = '';
  let locationNameParam = '';
  let lengthOfStayParam = '';
  let priceParam = '';
  let maxOccupancyParam = '';
  let bathroomsParam = '';
  let bedroomsParam = '';

  if (!isEmpty(fromCheckIn)) {
    if (checkInCondition === EQUAL_FILTER) {
      checkInParam = `fromCheckIn=${fromCheckIn}&toCheckIn=${fromCheckIn}`;
      filterApplied = true;
    } else if (checkInCondition === GREATER_FILTER) {
      checkInParam = `fromCheckIn=${fromCheckIn}`;
      filterApplied = true;
    } else if (checkInCondition === LOWER_FILTER) {
      checkInParam = `toCheckIn=${fromCheckIn}`;
      filterApplied = true;
    } else if (checkInCondition === RANGE_FILTER && !isEmpty(toCheckIn)) {
      checkInParam = `fromCheckIn=${fromCheckIn}&toCheckIn=${toCheckIn}`;
      filterApplied = true;
    }
  }

  if (!isEmpty(fromCheckOut)) {
    if (checkOutCondition === EQUAL_FILTER) {
      checkOutParam = `${filterApplied ? '&' : ''}fromCheckOut=${fromCheckOut}&toCheckOut=${fromCheckOut}`;
      filterApplied = true;
    } else if (checkOutCondition === GREATER_FILTER) {
      checkOutParam = `${filterApplied ? '&' : ''}fromCheckOut=${fromCheckOut}`;
      filterApplied = true;
    } else if (checkOutCondition === LOWER_FILTER) {
      checkOutParam = `${filterApplied ? '&' : ''}toCheckOut=${fromCheckOut}`;
      filterApplied = true;
    } else if (checkOutCondition === RANGE_FILTER && !isEmpty(toCheckOut)) {
      checkOutParam = `${filterApplied ? '&' : ''}fromCheckOut=${fromCheckOut}&toCheckOut=${toCheckOut}`;
      filterApplied = true;
    }
  }

  if (!isEmpty(locationName) && (locationName?.length || 0) > 0) {
    locationNameParam = `${filterApplied ? '&' : ''}${locationName?.map((name, i) => `locationIds[${i}]=${name}`).join('&')}`;
    filterApplied = true;
  }

  if (lengthOfStay != null && lengthOfStay !== undefined) {
    lengthOfStayParam = `${filterApplied ? '&' : ''}lengthOfStay=${lengthOfStay}`;
    filterApplied = true;
  }

  if (maxOccupancy != null && maxOccupancy !== undefined) {
    maxOccupancyParam = `${filterApplied ? '&' : ''}maxOccupancy=${maxOccupancy}`;
    filterApplied = true;
  }

  if (bathrooms != null && bathrooms !== undefined) {
    bathroomsParam = `${filterApplied ? '&' : ''}bathrooms=${bathrooms}`;
    filterApplied = true;
  }

  if (bedrooms != null && bedrooms !== undefined) {
    bedroomsParam = `${filterApplied ? '&' : ''}bedrooms=${bedrooms}`;
    filterApplied = true;
  }

  if (startPrice != null && startPrice !== undefined) {
    if (priceCondition === EQUAL_FILTER) {
      priceParam = `${filterApplied ? '&' : ''}startPrice=${startPrice}&endPrice=${startPrice}`;
      filterApplied = true;
    } else if (priceCondition === GREATER_FILTER) {
      priceParam = `${filterApplied ? '&' : ''}startPrice=${startPrice}`;
      filterApplied = true;
    } else if (priceCondition === LOWER_FILTER) {
      priceParam = `${filterApplied ? '&' : ''}endPrice=${startPrice}`;
      filterApplied = true;
    } else if (priceCondition === RANGE_FILTER && endPrice != null && endPrice !== undefined) {
      priceParam = `${filterApplied ? '&' : ''}startPrice=${startPrice}&endPrice=${endPrice}`;
      filterApplied = true;
    }
  }

  return {
    params: `${filterApplied ? '&' : ''}${checkInParam}${checkOutParam}${locationNameParam}${lengthOfStayParam}${priceParam}${bedroomsParam}${bathroomsParam}${maxOccupancyParam}`,
    filterApplied
  };
}


export const ProcessFilterParamsObject = (filters: ICondoWeeksFilters) => {
  const checkInCondition = filters?.checkInCondition;
  const fromCheckIn = filters?.fromCheckIn;
  const toCheckIn = filters?.toCheckIn;
  const checkOutCondition = filters?.checkOutCondition;
  const fromCheckOut = filters?.fromCheckOut;
  const toCheckOut = filters?.toCheckOut;
  const locationName = filters?.locationName;
  const lengthOfStay = filters?.lengthOfStay;
  const priceCondition = filters?.priceCondition;
  const startPrice = filters?.startPrice;
  const endPrice = filters?.endPrice;
  const maxOccupancy = filters?.occupancy;
  const bedrooms = filters?.bedrooms;
  const bathrooms = filters?.bathrooms;

  let filterApplied = false;
  const params: Record<string, any> = {};

  if (!isEmpty(fromCheckIn)) {
    if (checkInCondition === EQUAL_FILTER) {
      params.fromCheckIn = fromCheckIn;
      params.toCheckIn = fromCheckIn;
      filterApplied = true;
    } else if (checkInCondition === GREATER_FILTER) {
      params.fromCheckIn = fromCheckIn;
      filterApplied = true;
    } else if (checkInCondition === LOWER_FILTER) {
      params.toCheckIn = fromCheckIn;
      filterApplied = true;
    } else if (checkInCondition === RANGE_FILTER && !isEmpty(toCheckIn)) {
      params.fromCheckIn = fromCheckIn;
      params.toCheckIn = toCheckIn;
      filterApplied = true;
    }
  }

  if (!isEmpty(fromCheckOut)) {
    if (checkOutCondition === EQUAL_FILTER) {
      params.fromCheckOut = fromCheckOut;
      params.toCheckOut = fromCheckOut;
      filterApplied = true;
    } else if (checkOutCondition === GREATER_FILTER) {
      params.fromCheckOut = fromCheckOut;
      filterApplied = true;
    } else if (checkOutCondition === LOWER_FILTER) {
      params.toCheckOut = fromCheckOut;
      filterApplied = true;
    } else if (checkOutCondition === RANGE_FILTER && !isEmpty(toCheckOut)) {
      params.fromCheckOut = fromCheckOut;
      params.toCheckOut = toCheckOut;
      filterApplied = true;
    }
  }

  if (!isEmpty(locationName) && (locationName?.length || 0) > 0) {
    params.locationIds = locationName;
    filterApplied = true;
  }

  if (lengthOfStay != null && lengthOfStay !== undefined) {
    params.lengthOfStay = lengthOfStay;
    filterApplied = true;
  }

  if (maxOccupancy != null && maxOccupancy !== undefined) {
    params.maxOccupancy = maxOccupancy;
    filterApplied = true;
  }

  if (bathrooms != null && bathrooms !== undefined) {
    params.bathrooms = bathrooms;
    filterApplied = true;
  }

  if (bedrooms != null && bedrooms !== undefined) {
    params.bedrooms = bedrooms;
    filterApplied = true;
  }

  if (startPrice != null && startPrice !== undefined) {
    if (priceCondition === EQUAL_FILTER) {
      params.startPrice = startPrice;
      params.endPrice = startPrice;
      filterApplied = true;
    } else if (priceCondition === GREATER_FILTER) {
      params.startPrice = startPrice;
      filterApplied = true;
    } else if (priceCondition === LOWER_FILTER) {
      params.endPrice = startPrice;
      filterApplied = true;
    } else if (priceCondition === RANGE_FILTER && endPrice != null && endPrice !== undefined) {
      params.startPrice = startPrice;
      params.endPrice = endPrice;
      filterApplied = true;
    }
  }

  return {
    params,
    filterApplied
  };
}

